import React, { useState, useCallback } from "react";
import LoadTermsAndConditions from "./termsAndConditions/LoadTermsAndConditions";
import NscDeliveryRanges from "./deliveryRanges/nsc/NscDeliveryRanges";
import HasPermissionTo from "../../common/HasPermissionTo";
import AldCupidId from "./AldCupidId";
import LeadTimes from "./leadTimes/LeadTimes";
import { withTranslation } from "react-i18next";
import SubNav from "../../shared/subnav/SubNav";
import PaymentThreshold from "./paymentThreshold/PaymentThreshold";
import TranslationDetails from "../translations/TranslationDetails";

function NscBusinessSettings(props) {
  const [selectedTab, setSelectedTab] = useState(props.startingTab);

  const handleTabChange = useCallback((event, selectedTab) => {
    setSelectedTab(selectedTab);
  }, []);

  const getTabs = useCallback(() => {
    return [
      {
        menuName: props.t("ProgressBar.termsConditions"),
        enabled: true,
        id: "empMembership",
      },
      {
        menuName: props.t("ProgressBar.deliveryRanges"),
        enabled: true,
        id: "deliveryRanges",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "deliveryRangesTab"
        ),
      },
      {
        menuName: props.t("BusinessSettings.aldCupid"),
        enabled: true,
        id: "aldCupidId",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "aldCupidIdTab"
        ),
      },
      {
        menuName: props.t("ProgressBar.leadTimes"),
        enabled: true,
        id: "leadTimes",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "leadTimesTab"
        ),
      },
      {
        menuName: props.t("PaymentThreshold.tabCaption"),
        enabled: true,
        id: "paymentThreshold",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "paymentThresholdTab"
        ),
      },
      {
        menuName: props.t("ProgressBar.translations"),
        enabled: true,
        id: "translations",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "translationsTab"
        ),
      },
      {
        menuName: props.t("ConversionRate.tabCaption"),
        enabled: true,
        id: "conversionRate",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "conversionRateTab"
        ),
      },
    ];
  }, [props.t, props.user]);

  const getVisibleTabs = useCallback(() => {
    return getTabs().filter(tab => !tab.hide);
  }, [getTabs]);

  const visibleTabs = getVisibleTabs();
  const currentTab = visibleTabs[selectedTab];

  return (
    <div>
      <div style={{ position: 'relative', zIndex: 100 }}>
        <SubNav
          dashboard={false}
          selectedTab={selectedTab}
          title={props.t("GlobalNavBar.settings")}
          action={handleTabChange}
          tabs={visibleTabs}
          restrictDropdown={props.restrictDropdown}
          {...props}
        />
      </div>
      <div className="pageWrapper">
        {currentTab?.id === "empMembership" && (
          <LoadTermsAndConditions {...props} />
        )}
        <HasPermissionTo
          perform={["deliveryRangesTab"]}
          permissions={props.user.permissions.rolePermissions}
          condition={currentTab?.id === "deliveryRanges"}
          render={() => (
            <NscDeliveryRanges {...props} />
          )}
        />
        <HasPermissionTo
          perform={["aldCupidIdTab"]}
          permissions={props.user.permissions.rolePermissions}
          condition={currentTab?.id === "aldCupidId"}
          render={() => {
            return <AldCupidId {...props} />;
          }}
        />
        <HasPermissionTo
          perform={["leadTimesTab"]}
          permissions={props.user.permissions.rolePermissions}
          condition={currentTab?.id === "leadTimes"}
          render={() => <LeadTimes {...props} />}
        />
        <HasPermissionTo
          perform={["paymentThresholdTab"]}
          permissions={props.user.permissions.rolePermissions}
          condition={currentTab?.id === "paymentThreshold"}
          render={() => <PaymentThreshold {...props} />}
        />
        <HasPermissionTo
          perform={["translationsTab"]}
          permissions={props.user.permissions.rolePermissions}
          condition={currentTab?.id === "translations"}
          render={() => <TranslationDetails {...props} />}
        />
      </div>
    </div>
  );
}

export default withTranslation("emp")(NscBusinessSettings);
